import type { Faq } from '../types/offer';
export const faqs: Faq[] = [{
  question: 'এটা কি শুধু ফ্রিল্যান্সারদের জন্য?',
  answer: 'না। ফ্রিল্যান্সার, উদ্যোক্তা, চাকরিজীবী, শিক্ষার্থী — চ্যাম্পিয়ন মাইন্ডসেট গড়ে বেশি আয় করতে চান এমন যে কারও জন্যই এই সিস্টেম। আপনি ব্যবসা শুরু করছেন বা করপোরেট ক্যারিয়ারে এগোচ্ছেন, দুই ক্ষেত্রেই এটি কাজ করে।'
}, {
  question: 'ফল দেখতে কত সময় লাগে?',
  answer: 'বেশিরভাগ মানুষ ৪৮ ঘণ্টার মধ্যেই নিজের চিন্তায় পরিবর্তন টের পান। বাস্তব ফলাফল (বেশি ক্লায়েন্ট, বেশি টাকা, বেশি আত্মবিশ্বাস) সাধারণত ৩০ দিনের মধ্যে আসে, যদি আপনি নিয়মিত প্রয়োগ করেন।'
}, {
  question: '৪০০+ পৃষ্ঠা পড়ার সময় না থাকলে কী হবে?',
  answer: 'প্রতিটি তোমো ছোট ছোট অংশে পড়ার জন্য সাজানো। অনেকেই দিনে ১৫-২০ মিনিট পড়ে ২-৩ সপ্তাহে শেষ করেন। এছাড়া ডিকশনারি ও ওয়ার্কবুক দ্রুত রেফারেন্স হিসেবে ব্যবহার করতে পারেন।'
}, {
  question: 'এটা কি বাংলায় পাওয়া যাবে?',
  answer: 'মূল কনটেন্ট প্রিমিয়াম মানের ইংরেজিতে, তবে আমরা অনূদিত সারসংক্ষেপ এবং বাংলা ব্যাখ্যাসহ সম্পূর্ণ ডিকশনারি দিয়ে থাকি।'
}, {
  question: 'যদি আমার কাজে না লাগে?',
  answer: 'আমরা ৭ দিনের, কোনো প্রশ্ন ছাড়াই মানি-ব্যাক গ্যারান্টি দিই। স্ট্র্যাটেজিগুলো প্রয়োগ করেও ফল না পেলে ১০০% টাকা ফেরত পাবেন। আমরা এতটাই আত্মবিশ্বাসী।'
}, {
  question: 'বন্ধুদের সাথে শেয়ার করতে পারি?',
  answer: 'এটি ব্যক্তিগত ব্যবহারের লাইসেন্স। তবে নিজের ব্যবসা বা প্রতিষ্ঠানের সাথে শেয়ার করতে চাইলে আমাদের বাল্ক ডিসকাউন্ট ও টিম লাইসেন্স আছে।'
}];
